"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useOnTabOutside(
//** useRef or el: element to click outside of */
ref, 
//** onTabOutside: callback function */
onTabOutside, 
//** deps: array of state dependencies that are referenced inside callback. defaults to [] */
deps) {
    if (deps === void 0) { deps = []; }
    var onKeyDown = function (e) {
        var isTab = e.key === 'Tab' || e.keyCode === 9;
        if (isTab && ref.current) {
            setTimeout(function () {
                //if tabbed outside of ref element
                if (ref.current && !ref.current.contains(document.activeElement)) {
                    onTabOutside(e);
                }
            });
        }
    };
    react_1.useEffect(function () {
        document.documentElement.addEventListener('keydown', onKeyDown, false);
        return function () {
            document.documentElement.removeEventListener('keydown', onKeyDown, false);
        };
    }, deps);
}
exports.useOnTabOutside = useOnTabOutside;
